import { Box } from '@chakra-ui/core'
import { StatusesMenu } from 'components/ServiceCalls/StatusesMenu'
import React, { useCallback } from 'react'
import { CHART_COLORS } from 'utils/taskAnalytics'

const STATUSES = [
  { color: 'transparent', name: 't_all_tasks', value: -1 },
  { color: CHART_COLORS.todoText, name: 'task_status_todo', value: 0 },
  { color: CHART_COLORS.inProgressText, name: 'task_status_inprogress', value: 1 },
  { color: CHART_COLORS.doneText, name: 'task_status_done', value: 2 },
  { color: CHART_COLORS.approvedText, name: 'task_status_approved', value: 4 }, // APPROVED
  { color: CHART_COLORS.rejectedText, name: 'task_status_rejected', value: 3 }, // DISAPPROVED
]

interface IProps {
  selectedStatusValue: number
  setSelectedStatusValue: React.Dispatch<React.SetStateAction<number>>
}
export const TasksStatusesMenu: React.FC<IProps> = ({ selectedStatusValue, setSelectedStatusValue }) => {
  const handleChangeStatus = useCallback(
    (value: number) => {
      setSelectedStatusValue(value)
    },
    [setSelectedStatusValue]
  )

  return (
    <Box maxW="200px" w="100%" isTruncated>
      <StatusesMenu
        statuses={STATUSES}
        statusValue={selectedStatusValue}
        handleChangeStatus={handleChangeStatus}
        boxShadow="none"
        border="1px solid #E2E8F0"
        h="40px"
      />
    </Box>
  )
}
